<nz-layout>
  <nz-header class="bg-primary text-white">
    <div class="header-title" (click)="navigateToRoot()">
      <img
        class="provadis-logo mr-4 inline-block"
        src="/assets/provadis-logo-white.svg"
        alt="Provadis Logo"
      />
      <span class="text-white font-bold"
        >Provadis Kleidungs- und Spindverwaltungssystem</span
      >
    </div>
    <div
      *ngIf="isLoggedIn$ | async"
      class="ml-auto text-white flex items-center"
    >
      <div class="pr-1.5">{{ loggedInName$ | async }}</div>
      <a href="#" class="pl-5" (click)="logout()"
        >Logout
        <span class="pl-1.5" nz-icon nzType="logout" nzTheme="outline"></span
      ></a>
    </div>
  </nz-header>
  <ng-container *ngIf="isLoggedIn$ | async; else loginPage">
    <nz-layout>
      <nz-sider [nzCollapsible]="true" nzBreakpoint="lg">
        <ul nz-menu nzTheme="dark" nzMode="inline">
          <li
            nz-menu-item
            routerLink="/home"
            routerLinkActive="active-menu-item"
          >
            <span nz-icon nzType="project"></span>
            <span>Dashboard</span>
          </li>
          <li
            routerLink="/lockers"
            routerLinkActive="active-menu-item"
            nz-menu-item
          >
            <span nz-icon nzType="database"></span>
            <span>Spindverwaltung</span>
          </li>
          <li
            routerLink="/provisions"
            routerLinkActive="active-menu-item"
            nz-menu-item
          >
            <span nz-icon nzType="form"></span>
            <span>Versorgungsanfragen</span>
          </li>
          <li
            nz-menu-item
            routerLink="/persons"
            routerLinkActive="active-menu-item"
          >
            <span nz-icon nzType="user"></span>
            <span>Personenverwaltung</span>
          </li>
          <li
            nz-menu-item
            routerLink="/clothing"
            routerLinkActive="active-menu-item"
          >
            <span nz-icon nzType="skin"></span>
            <span>Kleiderverwaltung</span>
          </li>
        </ul>
      </nz-sider>
      <nz-content class="bg-white">
        <router-outlet></router-outlet>
      </nz-content>
    </nz-layout>
  </ng-container>
  <ng-template #loginPage>
    <nz-layout>
      <nz-content class="p-5">
        <router-outlet></router-outlet>
      </nz-content>
    </nz-layout>
  </ng-template>
</nz-layout>
